import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import useNavigation from "../../utils/useNavigation";

/**
 * Route Synchronization Component
 * This component listens to route changes and ensures navigation state is synced
 * with browser history, especially for back/forward navigation
 */
const RouteSync = () => {
  const location = useLocation();
  const { syncWithRoute } = useNavigation();
  const previousPathRef = useRef(location.pathname);

  useEffect(() => {
    const currentPath = location.pathname;
    const previousPath = previousPathRef.current;

    // Only sync if the route actually changed
    if (currentPath !== previousPath) {
      // Sync navigation state with current route
      syncWithRoute(currentPath);
      
      // Update previous path reference
      previousPathRef.current = currentPath;
    }
  }, [location.pathname, syncWithRoute]);

  // Sync on initial mount
  useEffect(() => {
    syncWithRoute(location.pathname);
  }, []);

  // This component doesn't render anything
  return null;
};

export default RouteSync;
